import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import {
  checkCodeRequest,
  checkCodeSuccess,
  checkCodeFail,
  processLinkSuccess,
  processLinkFail,
  resetCodeError,
  setCodeError,
  setRedirectUrl,
  codeParamsRequest,
  codeParamsSuccess,
  codeParamsFail,
} from './code.actions';
import { IResponseCodeParams } from './code.types';

export interface ICodeState {
  isLoading: boolean;
  redirectUrl: string;
  errors: TLegacyErrors;
  params: IResponseCodeParams | null;
}

export const initialState: ICodeState = {
  isLoading: false,
  redirectUrl: '',
  errors: {},
  params: null,
};

const reducer = createReducer<ICodeState>({}, initialState);

reducer
  .on(checkCodeRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(checkCodeSuccess, state => ({
    ...state,
    isLoading: false,
  }))
  .on(checkCodeFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }))
  .on(processLinkFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(processLinkSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    redirectUrl: payload,
  }))
  .on(processLinkFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(resetCodeError, state => ({
    ...state,
    isLoading: false,
    errors: {},
    params: null,
  }))
  .on(setCodeError, (state, payload) => ({
    ...state,
    errors: { code: payload.code },
    params: payload.params ?? null,
  }))
  .on(setRedirectUrl, (state, payload) => ({
    ...state,
    redirectUrl: payload,
  }));

reducer
  .on(codeParamsRequest, state => ({
    ...state,
    isLoading: true,
    params: null,
  }))
  .on(codeParamsSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    params: payload ?? null,
  }))
  .on(codeParamsFail, state => ({
    ...state,
    isLoading: false,
    params: {
      header: 'Try again later',
      message: 'Something went wrong. Please try again later or reach out to us, so we can help.',
    },
  }));

export default reducer;
